import RoomPicker from './RoomPicker.component';
export default RoomPicker;